// src/hooks/useAI.js
// Routes are served by the standalone Cloudflare Worker in workers/ai-worker/,
// mapped to the portfolio domain via a Cloudflare Worker Route.
// See workers/ai-worker/README.md for route configuration details.

// Empty base — all requests use relative paths, proxied in dev via src/setupProxy.js
// (which injects Origin: http://localhost:3000 so the Worker's isAllowedSource check passes)
// and served same-origin in production via Cloudflare Worker Routes.
const AI_BASE_URL = ''

async function post(path, body) {
  const res = await fetch(`${AI_BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
  if (!res.ok) throw new Error(`AI request failed: ${res.status}`)
  return res.json()
}

export function useAI() {
  const chat = (message, history = []) => post('/api/ai/chat', { message, history })
  const detectVisitor = (referrer = '', hint = '') => post('/api/ai/visitor', { referrer, hint })
  const analyzePage = (section, content) => post('/api/ai/analyze', { section, content })

  return { chat, detectVisitor, analyzePage }
}
